/**
 * Use this function to redirect to an external page
 */
export const redirectTo = (url: string) => {
  window.location.href = url;
};
